import { useMutation } from '@tanstack/react-query';
import { postStoreReserve } from '../store.service';
import { StoreReserveRequest } from '../types/store.type';

export const useStoreReserve = () => {
  return useMutation({
    mutationFn: (body: StoreReserveRequest) => postStoreReserve(body),
  });
};
